<template>
  <div
    :class="[isOpen ? 'transform translate-x-0':'transform -translate-x-full invisible lg:visible', {'is-collapsed': collapse}]"
    class="aside-core bg-primary-50 dark:bg-darkblue flex flex-col z-2010"
  >
    <header class="lg:hidden flex-none flex items-center justify-center bg-white dark:bg-darkblue select-none">
      <base-logo
        :filename="logo"
        :apiImage="true"
        alt="EdasInvoiZE - Dashboard"
        class="brand p-2 max-w-xs max-h-20"
      />
    </header>
    <div class="relative overflow-auto h-full dark:bg-darkblue select-none">
      <base-aside-main-nav
        class="relative z-20  lg:block"
        @cover="toggleCover"
        v-if="secondaryMenuOptions.length"
        :items="mainMenuOptions"
      />
      <nav
        :class="{'opacity-25':cover}"
        class="aside-nav transition-opacity duration-300 mt-8"
      >
        <base-aside-nav
          :items="secondaryMenuOptions.length ? secondaryMenuOptions : mainMenuOptions"
        />
      </nav>
    </div>
    <div class="hidden flex items-center lg:block mt-auto justify-center py-2 collapsed-area select-none">
      <!-- <div class="flex flex-row"> -->
        <base-button-icon
            @click="toggleCollapsed"
            :name="isCollapsed"
            mode="primary-phantom"
            class="bg-primary-100 hover:bg-primary-200 dark:bg-darkblue-800 dark:text-darkblue-200 rounded-full w-11 relative z-20"
          />
        <span class="flex items-center justify-center mb-2 relative z-10">
          <a
            href='https://www.zerocoma.com'
            target="_blank"
          >
          <base-logo-partner
            class="w-40 p-2"
            alt="ZeroComa"
            :filename="logoPartner"
            />
          </a>
        </span>
      <!-- </div> -->
    </div>
    <footer class="flex-none pb-3 lg:hidden dark:bg-darkblue border-t dark:border-solid dark:border-darkblue-600  select-none">
      <transition-group
        name="accordeon"
        @enter="startTransition"
        @after-enter="endTransition"
        @before-leave="startTransition"
        @after-leave="endTransition"
      >
        <div
          v-if="showOptions"
          class="overflow-x-auto overflow-y-hidden px-4 pt-2 max-h-56  dark:bg-darkblue"
          key="options"
        >

            <base-drop-down
            :isOpen="showOptions"
            position="relative top-left"
            autoClose=false
            :absolute="false"
            @toggle="toggleOptions"
          >
            <div class="p-1">
              <p @click="changeDarkMode()" class="capitalize cursor-pointer focus:outline-none group flex rounded-md items-center w-full px-2 py-2 text-sm bg-white dark:bg-darkblue dark:text-darkblue-200 lg:dark:bg-darkblue-900 hover:bg-primary-50 dark:hover:bg-darkblue hover:text-primary active:bg-primary-100 dark:active:bg-darkblue-600 dark:focus:bg-darkblue-600 dark:focus:text-primary">
                <base-icon name="darktheme" class="mr-2" />
                {{ mode }}
              </p>
            </div>
            <ul class="p-1 divide-y divide-gray-50 dark:divide-gray-800 dark:border-darkblue-600">
              <base-link-item-nav v-for="option in userOptions" :option="option" :key="option.name" />
            </ul>
            </base-drop-down>
          </div>
        <div
          v-if="showConfig"
          class="overflow-x-auto px-4 pt-2 max-h-56 bg-white dark:bg-darkblue"
          key="config"
        >
          <div
            class="px-1 py-1"
            v-if="showConfig"
          >
            <base-link-item-nav
              v-for="link in configOptions"
              :option="link"
              :key="link.name"
            />
          </div>
        </div>
      </transition-group>
      <div class="px-4 core-items flex items-center justify-between">
        <div class="py-3">
          <base-avatar :isOpen="showOptions" @toggleAvatar="toggleOptions" v-bind:onMobile="true" custom="bg-primary-100 dark:bg-darkblue-800 dark:text-darkblue-200" />
        </div>
        <div v-if="!(isRoleUserConsulta || isRoleProvider) && hasModuleInterfazEmision" class="relative">
          <base-button-icon
            v-if="!(isRoleUserConsulta || isRoleProvider)"
            @click="gotoIssuing()"
            name="docblack"
            mode="bubble"
            class="bg-primary-100 dark:bg-darkblue-800 dark:text-darkblue-200 dark:hover:bg-darkblue-600 rounded-full hover:text-primary dark:hover:text-primary"
          />
              <span v-if="!(isRoleUserConsulta || isRoleProvider)" v-show="actualFilterIssuing" class='badge badge-warning absolute top-2 left-2 z-20 badge-count-visited'
                v-popover:popoverIssuing>
                <base-icon name="filter" size="xs" />
              </span>
              <el-popover v-if="!(isRoleUserConsulta || isRoleProvider)" ref="popoverIssuing" placement="bottom" width="320" trigger="hover"
                popper-class="dark:bg-darkblue dark:border-darkblue-600 dark:text-darkblue-200">
                <div>
                  <div v-if="actualFilterIssuing">
                    <div class="flex items-center justify-between">
                      <span class="text-lg">{{$i18n.t('app.client_filter')}}</span>
                      <base-button-icon @click="resetIssuingFilter()" name="cross" iconSize="xs" size="xs"
                        mode="primary-phantom"
                        class="ml-2 bg-primary-100 hover:bg-primary-200 dark:bg-darkblue-800 dark:text-darkblue-200 rounded-full" />
                    </div>
                    <div class="flex items-center justify-between">
                      <span>{{ actualFilterIssuing.idCliente }} - {{ actualFilterIssuing.Nombre }}</span>
                    </div>
                  </div>
                  <div v-else>
                    <span>{{$i18n.t('app.empty_client_filter')}}</span>
                  </div>
                </div>
              </el-popover>
        </div>
        <div v-if="!(isRoleUserConsulta || isRoleProvider)" class="relative">
          <base-button-icon
            v-if="!(isRoleUserConsulta || isRoleProvider)"
            @click="toggleUploadInvoice"
            name="export"
            mode="bubble"
            class="bg-primary-100 dark:bg-darkblue-800 dark:text-darkblue-200 dark:hover:bg-darkblue-600 rounded-full hover:text-primary dark:hover:text-primary"
          />
              <span v-if="!(isRoleUserConsulta || isRoleProvider)" v-show="actualFilterUploads" class='badge badge-warning absolute top-2 left-2 z-20 badge-count-visited'
                v-popover:popoverUpload>
                <base-icon name="filter" size="xs" />
              </span>
              <el-popover v-if="!(isRoleUserConsulta || isRoleProvider)" ref="popoverUpload" placement="bottom" width="320" trigger="hover"
                popper-class="dark:bg-darkblue dark:border-darkblue-600 dark:text-darkblue-200">
                <div>
                  <div v-if="actualFilterUploads">
                    <div class="flex items-center justify-between">
                      <span class="text-lg">{{$i18n.t('app.client_filter')}}</span>
                      <base-button-icon @click="resetUploadsFilter()" name="cross" iconSize="xs" size="xs"
                        mode="primary-phantom"
                        class="ml-2 bg-primary-100 hover:bg-primary-200 dark:bg-darkblue-800 dark:text-darkblue-200 rounded-full" />
                    </div>
                    <div class="flex items-center justify-between">
                      <span>{{ actualFilterUploads.idCliente }} - {{ actualFilterUploads.Nombre }}</span>
                    </div>
                  </div>
                  <div v-else>
                    <span>{{$i18n.t('app.empty_client_filter')}}</span>
                  </div>
                </div>
              </el-popover>
        </div>
        <div ref="gotoDashboardDiv" :style="gotoDashboardStyle">
          <base-button-icon
            @click="gotoDashboard"
            name="dashboard"
            mode="bubble"
            class="bg-primary-100 dark:bg-darkblue-800 dark:text-darkblue-200 dark:hover:bg-darkblue-600 rounded-full hover:text-primary dark:hover:text-primary"
          />
        </div>
        <div class="relative" @click="toggleNotifications">
              <base-button-icon name="bell" mode="bubble" class="bg-primary-100 dark:bg-darkblue-800 dark:text-darkblue-200 dark:hover:bg-darkblue-600 rounded-full hover:text-primary dark:hover:text-primary"/>
              <span v-if="announcements !== null && announcements.length > 0"
                class='badge badge-warning absolute top-2 right-0 z-20'
                :class="alreadyVisited ? 'badge-count-visited' : 'badge-count'"> {{ $n(total, 'integer') }} </span>
              <span v-show="actualFilterAlerts" class='badge badge-warning absolute top-2 left-2 z-20 badge-count-visited'
                v-popover:popover>
                <base-icon name="filter" size="xs" />
              </span>
              <el-popover ref="popover" placement="bottom" width="320" trigger="hover"
                popper-class="dark:bg-darkblue dark:border-darkblue-600 dark:text-darkblue-200">
                <div>
                  <div v-if="actualFilterAlerts">
                    <div class="flex items-center justify-between">
                      <span class="text-lg">{{$i18n.t('app.client_filter')}}</span>
                      <base-button-icon @click="resetAlertsFilter()" name="cross" iconSize="xs" size="xs"
                        mode="primary-phantom"
                        class="ml-2 bg-primary-100 hover:bg-primary-200 dark:bg-darkblue-800 dark:text-darkblue-200 rounded-full" />
                    </div>
                    <div class="flex items-center justify-between">
                      <span>{{ actualFilterAlerts.idCliente }} - {{ actualFilterAlerts.Nombre }}</span>
                    </div>
                  </div>
                  <div v-else>
                    <span>{{$i18n.t('app.empty_client_filter')}}</span>
                  </div>
                </div>
              </el-popover>
            </div>
        <base-drop-down
            :isOpen="nots"
            position="relative top-left"
            customClass="w-[18rem]"
            autoClose=true
            @toggle="toggleNotifications"
          >
            <div class="p-4">
              <div v-if="announcements != null && announcements.length > 0">
                <div class="lg:mb-4 flex flex-row" v-for="(announcement, index) in announcements" :key="index">
                    <div class="lg:px-2 w-full mb-2 lg:mb-0">
                      <router-link v-if="announcement.Enlace !== null" :to="{ name: announcement.Enlace }"
                          href="#" class="child w-full flex items-center  pr-4 h-8
                          hover:bg-primary-100 dark:hover:bg-darkblue-900 active:bg-primary-200 group animate-hover rounded">
                          <span
                            class="cover-subnav w-full overflow-hidden pl-2 flex h-full border-l-2 border-solid items-center dark:border-darkblue-600"
                          >
                          <span class="link-name max-w-alertrow truncate group-hover:text-primary dark:text-secondary-200">{{ announcement.Mensaje }}</span>
                        </span>
                      </router-link>
                      <div v-else-if="announcement.Accion !== null" @click="onclickAnnouncement(announcement.Accion)"
                        class="child w-full flex items-center pr-4 h-8 cursor-pointer hover:bg-primary-100 dark:hover:bg-darkblue-900 active:bg-primary-200 group animate-hover rounded">
                        <span class="cover-subnav w-full overflow-hidden pl-2 flex h-full border-l-2 border-solid items-center dark:border-darkblue-600">
                          <span class="link-name max-w-alertrow truncate group-hover:text-primary dark:text-secondary-200">{{ announcement.Mensaje }}</span>
                        </span>
                      </div>
                      <span v-else class="cover-subnav w-full overflow-hidden pl-2 flex h-full border-l-2 border-solid items-center dark:text-secondary-200 dark:border-darkblue-600">{{ announcement.Mensaje }}</span>
                    </div>
                    <div class="lg:px-2 mt-1 mb-2 lg:mb-0">
                        <span v-if="announcement.NumeroAvisos !== 0" class='badge badge-warning right-0 z-20 cart-count active:bg-primary-200'>
                          {{ $n(announcement.NumeroAvisos, 'integer') }}
                        </span>
                    </div>
                </div>
              </div>
              <div class="flex items-center justify-center dark:text-secondary-200" v-else>
                <p>{{$t('avisos.announcements_empty')}}</p>
              </div>
            </div>
          </base-drop-down>
      </div>
      <div class="px-4 flex flex-col items-center justify-center">
        <a
          href='https://www.zerocoma.com'
          target="_blank"
        >
          <base-logo-partner
            class="brand w-32 pb-4"
            alt="ZeroComa"
            :filename="logoPartner"
          />
        </a>
        <base-button
          @click="toggleAside"
          mode="core"
          class="w-full"
          :text="$t('app.close_menu')"
        />
      </div>
    </footer>
    <div class="absolute hidden top-0 left-0 w-full h-full bg-transparent z-10 select-none"
      v-if="cover"
    />
    <help-dialog :dialogOpen="helpDialogOpen" @toggleDialog="toggleDialog" mobileVersion />
    <upload-invoice-dialog 
        :dialogOpen="uploadInvoiceDialog" 
        @toggleDialog="toggleUploadInvoice" 
        @applyDialog="applyUploadInvoice" 
        />
    <UploadInvoicesProgressDialog 
      :dialogOpen="uploadInvoiceProgressData.isOpen" :params="uploadInvoiceProgressData" 
      :recibidas="uploadInvoiceProgressData.recibidas" @toggleDialog="toggleUploadProgressInvoice"
      @applyDialog="applyUploadProgressInvoice" @resetDialog="resetUploadProgressInvoice" />
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'
import { i18n } from '@/i18n'
import { bus } from '@/main'

// import CompanySelectorDropDown from '@/components/CompanySelectorDropDown.vue'
import HelpDialog from '@/components/HelpDialog.vue'
import UploadInvoiceDialog from '@/components/UploadInvoiceDialog.vue'
import UploadInvoicesProgressDialog from '@/components/UploadInvoicesProgressDialog.vue'


export default {
  name: 'aside-core',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  components: {
    HelpDialog,
    UploadInvoiceDialog,
    UploadInvoicesProgressDialog,
  },
  data: function () {
    return {
      uploadInvoiceDialog: false,
      helpDialogOpen: false,
      aside: false,
      cover: false,
      collapse: false,
      footerModalNav: false,
      showConfig: false,
      showOptions: false,
      companySelect: [],
      productSelect: [],
      uploadInvoiceProgressData: {
        isOpen: false,
        idCliente: 0,
        idCIFEmpresa: 0,
        pgeType: null,
        autoSend: false,
        facturas: [],
        recibidas: false,
      },
      configOptions: [],
      mainMenuOptions: [],
      secondaryMenuOptions: [],
      nots: false,
      alreadyVisited: false,
      total: 0,
      gotoDashboardWidth: 44,
    }
  },
  computed: {
    isRoleProvider: function () {
      return this.role === 9
    },
    actualFilterAlerts () {
      return this.$store.getters['app/idClienteFilterAlerts']
    },
    actualFilterUploads () {
      return this.$store.getters['app/idClienteFilterAlerts']
    },
    actualFilterIssuing () {
      return this.$store.getters['app/idClienteFilterIssuing']
    },
    isRoleUserConsulta: function () {
      return this.role === 4 || this.role === 7 
    },
    darkMode: function () {
      return this.$store.getters['app/darkMode']
    },
    logo: function () {
      const pathBase = process.env.VUE_APP_API_URL + 'api/personalizacion/getrecurso?hash='
      const user = this.$store.getters['auth/user']

      // Personalizacion de logo
      if (user) {
        if (this.darkMode) {
          if (user.HashLogoDark) { 
            return pathBase + user.HashLogoDark 
          }
        } else {
          if (user.HashLogo) {
            return pathBase + user.HashLogo
          }
        }
      }

      if (this.darkMode) {
        return '/logos/logo-edasinvoize-dark.webp'
      }
      return '/logos/logo-edasinvoize.webp'
    },
    logoPartner: function () {
      const user = this.$store.getters['auth/user']

      // Personalizacion de logo
      if (user) {
        if (this.darkMode) {
          if (user.LogoPortalDark) {
            return 'logo-zc-edasinvoize-dark.webp'
          }
        }
        if (user.LogoPortal) {
          return 'logo-zc-edasinvoize.webp'
        }
      }
      if (this.darkMode) {
        return 'logo-zc-dark.webp'
      }
      return 'logo-zc.webp'
    },
    asideBehaviour: function () {
      return {
        'transform translate-x-0': this.isOpen,
        'transform -translate-x-full invisible lg:visible': !this.isOpen,
        'is-collapsed': this.collapse
      }
    },
    announcements: function () {
      const announcements = []
      const value = this.$store.getters['app/getAnnouncementsList']
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.total = 0
      if (value != null) {
        value.forEach(element => {
          announcements.push(element)
          this.total += element.NumeroAvisos
        })
      }
      return announcements
    },
    isCollapsed: function () {
      return (this.collapse ? 'expand' : 'collap')
    },
    mode: function () {
      if (this.darkMode === true) {
        return i18n.t('app.mode_light')
      } else {
        return i18n.t('app.mode_dark')
      }
    },
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    gotoDashboardStyle: function () {
      this.$set(this, 'gotoDashboardWidth', this.$refs?.gotoDashboardDiv?.getBoundingClientRect()?.width ?? 44)
      return !(this.isRoleUserConsulta || this.isRoleProvider) ? {} : {
        left: `calc(50% - (${this.gotoDashboardWidth}px / 2))`,
        position: 'absolute'
      }
    },
    userOptions: function () {
      const showHelp = this.showHelp
      return [
        {
          icon: 'user',
          name: i18n.t('app.user_profile'),
          click: function (store) {
            store.dispatch('auth/me', { navigate: true })
          }
        },
        {
          icon: 'help',
          name: i18n.t('app.help'),
          click: function () {
            showHelp()
          }
        },
        {
          icon: 'logout',
          name: i18n.t('app.logout'),
          click: function (store) {
            store.dispatch('auth/logout')
          }
        }
      ] 
    },
    hasModuleInterfazEmision: function () {
      return !!this.$store.getters['auth/hasModuleInterfazEmision']
    },
  },
  watch: {
    isLower1024: function (value, oldValue) {
      if (!value && this.helpDialogOpen) this.toggleDialog()
    },
    isOpen: function () {
      this.aside = this.isOpen
    },
    $route: function (to, from) {
      if (this.$tours.myTour.isRunning) this.$tours.myTour.stop()
      // this.$store.dispatch('app/updatetourFirstStepsActive', false)
      this.$store.dispatch('config/checkInactiveConfigs')

      this.cover = false
      this.updateInvoiceMenu()
      const menu = to?.meta?.secondaryMenu
      this.updateSecondaryMenu(menu)
      this.toggleAside()

      this.$store.dispatch('app/getAnnouncementsList')
      this.$store.dispatch('auth/getModules')
      this.$store.dispatch('auth/getPermisos')
    },
    announcements: function (value, oldValue) {
      if (value?.length > oldValue?.length) {
        this.alreadyVisited = false
      }
    },
    '$i18n.locale': function (value, oldValue) {
      if (value && value !== oldValue) {
        this.resetMainMenuOptions()
        this.updateNavEmitidas()
        this.updateNavRecibidas()
        this.updateNavVerifactu()
        const menu = this.$route?.meta?.secondaryMenu
        this.updateSecondaryMenu(menu)
      }
    }
  },
  beforeMount: async function () {
    this.$store.dispatch('app/getColumnsVistas')
  },
  created () {
    bus.$on('changeIt', (data) => {
      this.updateInvoiceMenu()
    })
    bus.$on('disableOptionsUser', (data) => {
      this.disableOptionsUser(data)
    })
    bus.$on('disableOptionsGroup', (data) => {
      this.disableOptionsGroup(data)
    })
    bus.$on('disableOptionsDistributor', (data) => {
      this.disableOptionsDistributor(data)
    })
    bus.$on('disableOptionsContact', (data) => {
      this.disableOptionsContact(data)
    })
  },
  mounted: async function () {
    this.$root.$on('openNotesPatchMobile', () => {
      this.$emit('toogleAside')
      this.showHelp()
      this.$root.$emit('setControlFlagPatchNotes')
    })
    await this.$store.dispatch('auth/getModules')
    await this.$store.dispatch('auth/getPermisos')

    this.updateMenus()

    this.toggleAside()

    this.$store.dispatch('app/getAnnouncementsList')
    this.$store.dispatch('auth/getModules')
  },
  methods: {
    updateMenus () {
      this.resetMainMenuOptions()
      this.updateInvoiceMenu()
      const menu = this.$route?.meta?.secondaryMenu
      this.updateSecondaryMenu(menu)
    },
    updateSecondaryMenu (menu) {
      this.secondaryMenuOptions = this.$store.getters['menu/secondaryMenu'](menu, this.$route.params)
      const type = this.$route.params.type !== undefined && this.$route.params.type !== null && this.$route.params.type !== '' ? parseInt(this.$route.params.type) : null
      this.secondaryMenuOptions.forEach(sm => {
        if (sm.menuId === 9) {
          if (type !== 99999) {
            sm.name = this.headerTitleRecibidas(type)
            sm.path = `/invoicesreceived/${type}`
          }
        }
        if (sm.menuId === 8) {
          if (type !== 99999) {
            sm.name = this.headerTitleEmitidas(type)
            sm.path = `/invoicesissued/${type}`
          }
        }
        if (sm.menuId === 16) {
          if (type !== 99999) {
            sm.name = this.headerTitleVerifactu(type)
            sm.path = `/verifactu/${type}`
          }
        }
      })
    },
    resetMainMenuOptions () {
      this.mainMenuOptions = []
      this.mainMenuOptions = this.$store.getters['menu/mainMenu']
    },
    resetAlertsFilter () {
      this.$store.dispatch('app/updateidClienteFilterAlerts', null)
      this.$store.dispatch('app/getAnnouncementsList')
    },
    resetUploadsFilter () {
      this.$store.dispatch('app/updateidClienteFilterUpload', null)
    },
    resetIssuingFilter () {
      this.$store.dispatch('app/updateidClienteFilterIssuing', null)
    },
    onclickAnnouncement (action) {
      // const data = { filters: [] }
      // Añadir aquí acciones de avisos que no dispongan de ruta propia
      console.error(i18n.t('feedback.error.unexpected_action_error', { action: JSON.stringify(action) }))
    },
    toggleUploadInvoice () {
      this.uploadInvoiceDialog = !this.uploadInvoiceDialog
    },
    
    /**
     * @param {Object} obj 
     * @param {Boolean} obj.background 
     * @param {{blnError: Boolean, codError: String, msgError: String, Respuesta: Boolean}[]|null} obj.results
     * @param {{idCliente: Number, idCIFEmpresa: Number, pgeType: String, autoSend: Boolean, facturas: Any[], recibidas: Boolean}} obj.params
     */
    applyUploadInvoice: async function ({ background = false, results = null, params = null }) {
      if (background) {
        this.uploadingInvoices = true
        this.toggleUploadInvoice()
      } else if (params?.facturas?.length > 0) {
        this.uploadInvoiceProgressData.idCliente = params.idCliente
        this.uploadInvoiceProgressData.idCIFEmpresa = params.idCIFEmpresa
        this.uploadInvoiceProgressData.pgeType = params.pgeType
        this.uploadInvoiceProgressData.autoSend = params.autoSend
        this.uploadInvoiceProgressData.facturas = params.facturas
        this.uploadInvoiceProgressData.recibidas = params.recibidas
        this.uploadingInvoices = true
        this.toggleUploadInvoice()
        this.toggleUploadProgressInvoice()
      } else {
        this.uploadingInvoices = false
        if (results?.length > 0) {
          const success1 = results.filter(x => !x.blnError)
          const errors = results.filter(x => x.blnError)
          if (errors.length > 0) {
            // TODO: Recargar avisos
            // this.$store.dispatch('app/getAnnouncementsList')

            // TODO: Generar avisos de errores
            this.$store.dispatch('app/addAnnouncement', { NumeroAvisos: errors.length, Mensaje: i18n.t('feedback.error.invoice_upload_error'), Enlace: 'notices/uploaderrors', params: errors })
          }
          if (success1.length > 0) {
            bus.$emit('changeIt', 'changed menu')
          }
        }
      }
    },
    toggleUploadProgressInvoice () {
      this.uploadInvoiceProgressData.isOpen = !this.uploadInvoiceProgressData.isOpen
    },
    applyUploadProgressInvoice: async function (data = { progress: [], success: true, background: false }) {
      if (data.background) {
        this.uploadingInvoices = true
        // TODO: Generar avisos de progreso
      } else {
        this.uploadingInvoices = false
        if (!data.success && data.progress.length > 0) {
        // TODO: Eliminar avisos de progreso
        // TODO: Generar avisos de errores
        }
      }
    },
    resetUploadProgressInvoice: function () {
      this.uploadInvoiceProgressData.idCliente = 0
      this.uploadInvoiceProgressData.idCIFEmpresa = 0
      this.uploadInvoiceProgressData.pgeType = null
      this.uploadInvoiceProgressData.autoSend = false
      this.uploadInvoiceProgressData.facturas = []
      this.uploadInvoiceProgressData.recibidas = false
    },
    showHelp: function () {
      this.toggleDialog()
    },
    toggleDialog: function () {
      this.helpDialogOpen = !this.helpDialogOpen
      if (!this.helpDialogOpen) this.$store.dispatch('app/updatelastVisitedPatchNotes')
    },
    disableOptionsUser: function (data) {
      this.secondaryMenuOptions.forEach(sm => {
        if (sm.name === i18n.t('users.header')) {
          sm.sc.forEach(sc => {
            if (sc.path === 'configurations/users/groups') {
              sc.disabled = data.disableGroups
            }
            if (sc.path === 'configurations/users/companies') {
              sc.disabled = data.disableCompanies
            }
            if (sc.path === 'configurations/users/status') {
              sc.disabled = data.disableStatuses
            }
            if (sc.path === 'configurations/users/providercompany') {
              sc.disabled = data.disableProviderCompanies
            }
          })
        }
      })
    },
    disableOptionsContact: function (data) {
      this.secondaryMenuOptions.forEach(sm => {
        if (sm.name === i18n.t('agenda.sociedad')) {
          sm.sc.forEach(sc => {
            if (sc.path === 'masters/society/usersproviders') {
              sc.disabled = data.disableUserProvider
              // sc.invisible = data.disableUserProvider
            }
            if (sc.path === 'masters/society/locations') {
              sc.disabled = data.disableSedes
              // sc.invisible = data.disableSedes
            }
            if (sc.path === 'masters/society/linkedcompanies') {
              sc.disabled = data.disableLinkedCompanies
              // sc.invisible = data.disableLinkedCompanies
            }
          })
        }
      })
    },
    disableOptionsGroup: function (data) {
      this.secondaryMenuOptions.forEach(sm => {
        if (sm.name === i18n.t('groups.header')) {
          sm.sc.forEach(sc => {
            if (sc.path === 'configurations/groups/users') {
              sc.disabled = data.disableUsers
            }
            if (sc.path === 'configurations/groups/companies') {
              sc.disabled = data.disableCompanies
            }
            if (sc.path === 'configurations/groups/status') {
              sc.disabled = data.disableStatuses
            }
          })
        }
      })
    },
    disableOptionsDistributor (data) {
      this.secondaryMenuOptions.forEach(sm => {
        if (sm.name === i18n.t('distributors.header')) {
          sm.sc.forEach(sc => {
            if (sc.path === 'configurations/distributors/modules') {
              sc.disabled = data.disableModules
            }
            if (sc.path === 'configurations/distributors/locations') {
              sc.disabled = data.disableLocations
            }
          })
        }
      })
    },
    toggleCover: function () {
      this.cover = !this.cover
    },
    toggleAside: function () {
      this.aside = false
      this.sendChanges()
      this.toggleAll()
    },
    toggleCollapsed: function () {
      this.collapse = !this.collapse
      this.sendChanges()
      this.$root.$emit('kendo-grid-componente-handle-resize')
    },
    toggleOptions: function () {
      this.showConfig = false
      this.showOptions = !this.showOptions
    },
    toggleConfig: function () {
      this.showOptions = false
      this.showConfig = !this.showConfig
    },
    toggleAll: function () {
      this.showOptions = false
      this.showConfig = false
    },
    startTransition: function (el) {
      el.style.height = el.scrollHeight + 'px'
    },
    endTransition: function (el) {
      el.style.height = ''
    },
    sendChanges: function () {
      this.$emit('toggle', {
        aside: this.aside,
        collapse: this.collapse
      })
    },
    headerTitleRecibidas: function (type) {
      const receivedInvoices = this.$store.getters['app/tiposAccionesFacturasRecibidas']
      const invoice = receivedInvoices.filter(sc => sc.idEstado === type)
      if (invoice.length > 0) {
        return invoice[0].Descripcion
      }
      return i18n.t('invoices.header')
    },
    headerTitleEmitidas: function (type) {
      const issuedInvoices = this.$store.getters['app/tiposAccionesFacturasEmitidas']
      const invoice = issuedInvoices.filter(sc => sc.idEstado === type)
      if (invoice.length > 0) {
        return invoice[0].Descripcion
      }
      return i18n.t('invoices.header')
    },
    headerTitleVerifactu: function (type) {
      const verifactus = this.$store.getters['app/tiposOperacionesVerifactus']
      const verifactu = verifactus.filter(sc => sc.idEstado === type)
      if (verifactu.length > 0) {
        return verifactu[0].Descripcion
      }
      return i18n.t('tipos.modulo_name.verifactu')
    },
    changeDarkMode: function () {
      this.$store.commit('app/setDarkMode', !this.darkMode)
    },
    gotoDashboard: function () {
      const uuid = this.guid()
      this.$router.push({ name: 'dashboard', params: { id: uuid } })
    },
    guid: function () {
      return uuidv4()
    },
    toggleNotifications: function () {
      this.nots = !this.nots
      this.alreadyVisited = true
    },
    announcementsTotal: function () {
      const value = this.$store.getters['app/getAnnouncementsList']
      let total = 0
      value.forEach(element => {
        total += element.NumeroAvisos
      })
      return total
    },
    updateInvoiceMenu: async function (updateRoute) {
      await this.$store.dispatch('app/getEstadosFacturas')
      this.updateNavEmitidas()
      this.updateNavRecibidas()
      this.updateNavVerifactu()
    },
    updateNavEmitidas: async function () {
      const invoices = this.$store.getters['app/tiposAccionesFacturasGroups']
      if (invoices != null) {
        this.mainMenuOptions.forEach(element => {
          if (element.menuId === 1) {
            element.sc = []
            element.subMenu = true

            // Recorremos grupos
            invoices.FacturasEmitidas.forEach(grupo => {
              var scGroup = {
                menuId: grupo.menuId,
                name: grupo.Descripcion,
                info: grupo.InfoAdicional,
                registerNavFromMenu: false,
                warning: grupo.Resaltado,
                desplegado: grupo.Desplegado,
                sc: []
              }
              // Recorremos estados del grupo
              grupo.Estados.forEach(estado => {
                const path = `/invoicesissued/${estado.idEstado}`
                scGroup.sc.push({
                  menuId: estado.menuId,
                  name: estado.Descripcion,
                  info: estado.InfoAdicional,
                  path: path,
                  counter: estado.Facturas,
                  registerNavFromMenu: false,
                  warning: estado.Resaltado,
                  sc: []
                })

                // Agregamos ruta, si existe reemplaza
                const newRoute = {
                  path: '/'+process.env.VUE_APP_ROUTE_BASE + path,
                  name: path,
                  components: { default: import('@/views/invoices/InvoicesIssued.vue') },
                  params: { id: estado.idEstado },
                  meta: { registerNavFromMenu: true, status: estado.idEstado }
                }
                this.$router.addRoute('invoicesissued', newRoute)
              })

              element.sc.push(scGroup)
            })
          }
        })
      }
    },
    updateNavRecibidas: async function () {
      const invoices = this.$store.getters['app/tiposAccionesFacturasGroups']
      if (invoices != null) {
        this.mainMenuOptions.forEach(element => {
          if (element.menuId === 2) {
            element.sc = []
            element.subMenu = true

            // Recorremos grupos
            invoices.FacturasRecibidas.forEach(grupo => {
              var scGroup = {
                menuId: grupo.menuId,
                name: grupo.Descripcion,
                info: grupo.InfoAdicional,
                registerNavFromMenu: false,
                warning: grupo.Resaltado,
                desplegado: grupo.Desplegado,
                sc: []
              }
              // Recorremos estados del grupo
              grupo.Estados.forEach(estado => {
                const path = `/invoicesreceived/${estado.idEstado}`
                scGroup.sc.push({
                  menuId: estado.menuId,
                  name: estado.Descripcion,
                  info: estado.InfoAdicional,
                  path: path,
                  counter: estado.Facturas,
                  registerNavFromMenu: false,
                  warning: estado.Resaltado,
                  sc: []
                })

                // Agregamos ruta, si existe reemplaza
                const newRoute = {
                  path: '/'+process.env.VUE_APP_ROUTE_BASE + path,
                  name: path,
                  components: { default: import('@/views/invoices/InvoicesReceived.vue') },
                  // components: { default: import('@/views/invoices/InvoicesReceived.vue') },
                  params: { id: estado.idEstado },
                  meta: { registerNavFromMenu: true, status: estado.idEstado }
                }
                this.$router.addRoute('invoicesreceived', newRoute)
              })

              element.sc.push(scGroup)
            })
          }
        })
      }
    },
    updateNavVerifactu: async function () {
      const invoicesVerifactu = this.$store.getters['app/tiposAccionesFacturasGroups']
      if (invoicesVerifactu != null) {
        this.mainMenuOptions.forEach(element => {
          if (element.menuId === 14) {
            element.sc = []
            element.subMenu = true

            // Recorremos grupos
            invoicesVerifactu.RegistrosVerifactu.forEach(grupo => {
              var scGroup = {
                menuId: grupo.menuId,
                name: grupo.Descripcion,
                info: grupo.InfoAdicional,
                registerNavFromMenu: false,
                warning: grupo.Resaltado,
                desplegado: grupo.Desplegado,
                sc: []
              }
              // Recorremos estados del grupo
              grupo.Estados.forEach(estado => {
                const path = `/verifactu/${estado.idEstado}`
                scGroup.sc.push({
                  menuId: estado.menuId,
                  name: estado.Descripcion,
                  info: estado.InfoAdicional,
                  path: path,
                  counter: estado.Facturas,
                  registerNavFromMenu: false,
                  warning: estado.Resaltado,
                  sc: []
                })

                // Agregamos ruta, si existe reemplaza
                const newRoute = {
                  path: '/'+process.env.VUE_APP_ROUTE_BASE + path,
                  name: path,
                  components: { default: import('@/views/invoices/Verifactus.vue') },
                  // components: { default: import('@/views/invoices/InvoicesReceived.vue') },
                  params: { id: estado.idEstado },
                  meta: { registerNavFromMenu: true, status: estado.idEstado }
                }
                this.$router.addRoute('verifactu', newRoute)
              })

              element.sc.push(scGroup)
            })
          }
        })
      }
    },
    gotoIssuing: function () {
      const uuid = this.guid()
      this.$router.push({ name: 'invoicesissuing', params: { id: uuid } })
    },
  }
}
</script>

<style lang="scss" scoped>
.filter-black{
  filter: invert(100%) sepia(2%) saturate(6%) hue-rotate(335deg) brightness(104%) contrast(99%);
}
.filter-white{
  filter: invert(0%) sepia(2%) saturate(6%) hue-rotate(335deg) brightness(104%) contrast(99%);
}
.filter-main{
  filter: invert(70%) sepia(94%) saturate(776%) hue-rotate(168deg) brightness(98%) contrast(91%);
}
.aside-core {
  @apply w-full fixed z-50 h-full transition-all duration-200;
  @include breakpoint(lg) {
    @apply static transform-none w-aside flex-shrink-0;

  }
  .collapsed-area>div {
    @apply ml-30 transition-all duration-200;
  }
  &.is-collapsed {
    @include breakpoint(lg) {
      @apply w-18 absolute;
      z-index: 40;
      &:hover {
        @apply w-aside;
      }
      .collapsed-area>div {
        @apply mr-auto ml-3;
      }
    }
  }
}
.accordeon-enter-active,
.accordeon-leave-active {
  will-change: height;
  transition: height 0.2s ease;
}
.accordeon-enter,
.accordeon-leave-to {
  height: 0 !important;
}
.badge {
  padding-left: 9px;
  padding-right: 9px;
  -webkit-border-radius: 9px;
  -moz-border-radius: 9px;
  border-radius: 9px;
}
.badge-count {
    font-size: 12px;
    background: #ff0000;
    color: #fff;
    padding: 0 5px;
    vertical-align: top;
    margin-left: -10px;
    margin-top: -15px;
}
.cart-count {
    font-size: 16px;
    @apply bg-primary-300;
    @apply dark:bg-primary-500;
    color: #fff;
    padding: 5px 10px;
    vertical-align: center;
    margin-top: -15px;
}

.badge-count-visited {
    font-size: 12px;
    @apply bg-primary-300;
    @apply dark:bg-primary-500;
    color: #fff;
    padding: 0 5px;
    vertical-align: top;
    margin-left: -10px;
    margin-top: -15px;
}

</style>
